import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-coupon-terms-and-conditions',
  templateUrl: './coupon-terms-and-conditions.component.html',
  styleUrls: ['./coupon-terms-and-conditions.component.scss'],
})
export class CouponTermsAndConditionsComponent implements OnInit {

  @Input() coupon = [];
  constructor(
    public modalService: NgbModal
  ) { }

  ngOnInit() { }

}
